<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <!-- Loading from page -->
    <full-loading v-if="loading"/>

    <div class="page-wrapper-row full-height">
      <div class="page-wrapper-middle">
        <div class="page-container">
          <div class="page-content-wrapper">
            <!-- Page Head -->
            <div class="page-head">
              <div class="container padding-bottom-12">
                <!-- Title -->
                <div class="col-md-3 padding-null">
                  <div class="page-title offset-top-4">
                    <h1>Administradores</h1>
                  </div>
                </div>
              </div>
            </div>

            <div class="page-content">
              <div class="container offset-top-20">
                <!-- Breadcrumb -->
                <ul class="page-breadcrumb breadcrumb breadcrumb-crud">
                  <li>
                    <a href="/dashboard">Dashboard</a>
                    <i class="fa fa-circle"></i>
                  </li>
                  <li>
                    <span class="breadcrumb-active">Administradores</span>
                  </li>
                </ul>

                <!-- Table -->
                <div v-if="!loading && dataAdmin.length" class="portlet light">
                  <div class="portlet-title">
                    <div class="caption">
                      <span
                        class="caption-subject font-blue bold uppercase">Quantidade total de admin ({{ dataAdmin.length }})</span>
                    </div>
                  </div>

                  <div class="portlet-body contate-table offset-top-20">
                    <div class="table-scrollable table-scrollable-borderless">
                      <table class="table table-hover table-light table-icon">
                        <thead>
                        <tr>
                          <th> EMPRESA</th>
                          <th> NOME</th>
                          <th> EMAIL</th>
                          <th> ÚLTIMO LOGIN</th>
                          <th> USUÁRIO CADASTRADO</th>
                          <th> EMPRESA CADASTRADA</th>
                          <th> AÇÕES</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="a in dataAdmin">
                          <td>{{ a.companyName }}</td>
                          <td>{{ a.name }}</td>
                          <td>{{ a.email }}</td>
                          <td>{{ a.lastLogin }}</td>
                          <td>{{ a.createdAt }}</td>
                          <td>{{ a.companyCreatedAt }}</td>
                          <td>
                            <a v-bind:href="'/usuario/' + a.userId" title="Visualizar" class="btn-to-view">
                              <i class="fa fa-eye" aria-hidden="true"></i> Visualizar
                            </a>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import swal from 'sweetalert';

import {
  ADMIN
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../../msgAlertService";

export default {
  name: "administrators",
  components: {
    topMenu,
    fullLoading
  },
  data() {
    return {
      loading: true,
      dataAdmin: ''
    }
  },
  methods: {
    getAdmin() {
      REQUEST_SERVICE.get(ADMIN + "?t=kkkk")
        .then((response) => {
          UTIL_SERVICE.console("RESULT ADMIN:", response.data);

          this.dataAdmin = response.data;
          this.loading = false;
        }).catch((reason) => {
        this.loading = false;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    }
  },
  beforeMount() {
    this.getAdmin();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/administrators/administrators.vue